import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import plakat1 from "../../../images/gosuslugi/plakat1.jpg";
import plakat2 from "../../../images/gosuslugi/plakat2.jpg";
import plakat3 from "../../../images/gosuslugi/plakat3.jpg";
import plakat4 from "../../../images/gosuslugi/plakat4.jpg";

export default function Gosuslugi() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Госуслуги
      </h1>

      <img
        alt="Клиника УрНИИ"
        className="clinicalbase__image"
        src={plakat1}
      ></img>

      <img
        alt="ЖЭкспериментально-лабораторная база"
        className="clinicalbase__image"
        src={plakat2}
      ></img>

      <img
        alt="ЖЭкспериментально-лабораторная база"
        className="clinicalbase__image"
        src={plakat3}
      ></img>

      <img
        alt="ЖЭкспериментально-лабораторная база"
        className="clinicalbase__image"
        src={plakat4}
      ></img>
    </section>
  );
}
